<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
	margin-top: 16px !important;
}

.items-center {
	align-items: center;
}

.justify-between {
	justify-content: space-between;
}

.flex {
	display: flex !important;
	width: 100%;
}

.flex-warp {
	flex-wrap: wrap;
}

.mr1 {
	margin-right: 1rem;
	word-wrap: +break-word;
	word-break: +norm;
}

.flexs {
	display: flex !important;
	width: 15%;
}
</style>
<template>
	<el-card shadow="never" class="l-main-card" v-loading="export_loading">
		<div class="l-table-app-user">
			<div class="flex flex-warp">
				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">用户ID：</p>
					<el-input placeholder="请输入用户Id" v-model="search_data.app_user_id" class="input-with-select"
						style="width: 76%;">
						<el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
					</el-input>
				</div>
				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">员工名：</p>
					<el-input placeholder="请输入员工名" v-model="search_data.admin_name" class="input-with-select"
						style="width: 76%;">
						<el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
					</el-input>
				</div>
				<!-- <div class="flexs items-center ivu-mt ivu-mr">
								<p class="mr1">所属APP：</p>
								<div class="l-show-more-search">
									<el-select v-model="search_data.app_type" placeholder="全部" clearable @change="changes"
										style="width: 100%;">
										<el-option v-for="item in app_list" :key="item.id" :label="item.name"
											:value="item.id"></el-option>
									</el-select>
								</div>
							</div> -->
				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">所属公司：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.corp_id" placeholder="全部" clearable @change="changes"
							style="width: 100%;">
							<el-option v-for="item in corp_list" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">所属部门：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.depart_id" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in depart_list" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">所属小组：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.group_id" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in group_list" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">用户标签：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.is_main" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in is_main" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>

				<!-- <div class="flexs items-center ivu-mt ivu-mr">
								<p class="mr1">绑定方式：</p>
						<div class="l-show-more-search">
							<el-select v-model="search_data.bind_type" placeholder="全部" clearable @change="changes">
								<el-option v-for="item in []" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
								</div>
							</div> -->
				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">绑定状态：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.bind_status" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in bind_status" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>

				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">优质用户：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.is_vip" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in is_vip" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>

				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">设备码：</p>
					<el-input placeholder="请输入设备码" v-model="search_data.RegMachineCode" class="input-with-select"
						style="width: 76%;">
						<el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
					</el-input>
				</div>

				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">日期</p>
					<div class="l-show-more-search">
						<el-date-picker style="width: 100%;" v-model="value2_check" type="datetimerange"
							@blur="onPick(false)" start-placeholder="开始日期" end-placeholder="结束日期"
							value-format="yyyy-MM-dd HH:mm:ss" @change="onPick(false)"></el-date-picker>
					</div>
				</div>


				<div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">绑定时间大于三天</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.is_export" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in is_3" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<div class="flexs items-center ivu-mt ivu-mr">
					<div class="l-show-more-search">
						<el-button type="info" auth="user_3_export" icon="el-icon-refresh"
							@click="exportS">导出</el-button>
					</div>
				</div>

				<div class="flexs items-center ivu-mt ivu-mr">
					<el-button type="default" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				</div>

			</div>
		</div>
		<div class="l-primary l-table-config" style=" border-bottom: solid 1px #e4e7ed;">
			<el-popover placement="bottom-start" width="200" trigger="click"
				popper-class="l-table-column-fixed-select-box">
				<span slot="reference">
					<i class="el-icon-setting"></i>表格列表配置
				</span>
				<div class>
					<div class="l-flex l-flex-just-between" style="margin-bottom:10px">
						<div>
							表格列表配置
							<i class="el-icon-refresh-left" style="float:right;  color: red;margin: 3px;"
								@click="resetFixedCheck">重置</i>
						</div>
					</div>
					<el-divider class="l-table-column-fixed-title-divider"></el-divider>
					<el-checkbox-group v-model="fixed_list">
						<div v-for="(item, id) in this.columnsList" :key="id">
							<el-checkbox :label="item.prop" style="margin-bottom:4px">{{ item.label }}</el-checkbox>
						</div>
					</el-checkbox-group>
				</div>
			</el-popover>
		</div>


		<l-table :data="data" v-loading="loading" @sort-change="sortOnlineTime">
			<el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" style="height: 100px;"
				:label="item.label" show-overflow-tooltip>
				<template v-slot="{ row }">
					<template v-if="item.prop == 'bind_type'">{{ BIND_TYPE[row.bind_type] }}</template>
					<template v-else-if="item.prop == 'bind_status'">{{ BIND_STATUS[row.bind_status] }}</template>
					<template v-else-if="item.prop == 'is_main'">{{ IS_MIAN[row.is_main] }}</template>
					<template v-else-if="item.prop == 'is_vip'">{{ IS_VIP[row.is_vip] }}</template>
					<template v-else-if="item.prop == 'app_id'">{{ APP_TYPE[row.app_id] }}</template>
					<template v-else-if="item.prop == 'caozou'">
						<l-auth-text-button type="primary" auth="app_user_edit_btn"
							@click="showEdit(row.app_user_id)"><i class="el-icon-edit"></i>详情</l-auth-text-button>
						<l-auth-text-button type="primary" auth="app_user_beautiful_btn" @click="beautiful(row.id)"><i
								class="el-icon-edit"></i>更新靓号</l-auth-text-button>
						<l-auth-text-button type="primary" auth="app_user_force_btn" @click="force(row.id)"><i
								class="el-icon-edit"></i>强制改绑</l-auth-text-button>
					</template>
					<template v-else>{{ row[item.prop] }}</template>
				</template>
			</el-table-column>
			<!-- <el-table-column fixed="right" label="操作" min-width="260" align="center">
				<template slot-scope="{ row }">
					<l-auth-text-button type="primary" auth="app_user_edit_btn" @click="showEdit(row.app_user_id)"><i
							class="el-icon-edit"></i>详情</l-auth-text-button>

					<l-auth-text-button type="primary" auth="app_user_beautiful_btn" @click="beautiful(row.id)"><i
							class="el-icon-edit"></i>更新靓号</l-auth-text-button>

					<l-auth-text-button type="primary" auth="app_user_force_btn" @click="force(row.id)"><i
							class="el-icon-edit"></i>强制改绑</l-auth-text-button>
				</template>
			</el-table-column> -->
		</l-table>

		<!--分页-->
		<l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
			:current-page.sync="page"></l-page>

		<!--编辑-->
		<l-dialog-new :visible.sync="edit_visible" title="详情" width="78%">
			<l-appuser-info @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id" />
		</l-dialog-new>

		<!--编辑-->
		<l-dialog :visible.sync="force_visible" title="强制改绑" width="500px">
			<l-app-user-force @on-success="onEditSucess" :visible.sync="force_visible" :id="force_id" />
		</l-dialog>

	</el-card>
</template>

<script>
// import Vue from "vue";
import { APP_TYPE, BIND_TYPE, IS_MIAN, IS_VIP, BIND_STATUS } from "./state";
import Info from "./Info.vue";
import Force from "./Force.vue";
export default {
	components: {
		[Info.name]: Info,
		[Force.name]: Force,
	},
	data() {
		return {
			is_vip: [
				{ "id": 0, "name": "否" },
				{ "id": 1, "name": "是" }
			],

			is_3: [
				{ "id": 200, "name": "否" },
				{ "id": 300, "name": "是" }
			],

			is_main: [
				{ "id": 1, "name": "小号" },
				{ "id": 2, "name": "大号" }
			],
			bind_status: [
				{ "id": 1, "name": "已绑定" },
				{ "id": 0, "name": "闲置未登录" },
				{ "id": 10, "name": "禁止绑定(拒绝)" }
			],
			data: [],
			count: 0,
			page: 1,
			page_size: 20,
			loading: false,
			change_state_loading: [],

			add_visible: false, //是否显示添加

			edit_visible: false, //是否显示编辑
			edit_id: 0,

			APP_TYPE: APP_TYPE,
			BIND_TYPE: BIND_TYPE,
			IS_MIAN: IS_MIAN,
			BIND_STATUS: BIND_STATUS,
			IS_VIP: IS_VIP,
			export_loading: false,
			//搜索
			search_visible: false,
			search_data: {
				app_user_id: "",
				app_type: "",
				corp_id: "",
				depart_id: "",
				group_id: "",
				admin_name: "",
				bind_type: "",
				bind_status: "",
				app_user_brisk: "",
				is_vip: "",
				is_main: "",
				start_time: "",
				end_time: "",
				RegMachineCode: "",
				sort: "",
				is_export: ""
			},
			rel_search_data: {},
			show_more_search: false,
			value2: "",
			value2_check: [],
			corp_list: [],
			depart_list: [],
			group_list: [],
			app_list: [],
			force_visible: false,
			force_id: 0,
			re_fixed_list: [
				"index",
				"DisplayId",
				"mobile",
				"user_name",
				"admin_name",
				"bind_status",
				"refuse_text",
				"is_main",
				"bind_status",
				"is_vip",
				"recharge_total",
				"guild_recharge_total",
				"Total",
				"bind_time",
				"caozou"
			],
			fixed_list: [
				"index",
				"DisplayId",
				"mobile",
				"user_name",
				"admin_name",
				"bind_status",
				"refuse_text",
				"is_main",
				"is_vip",
				"recharge_total",
				"guild_recharge_total",
				"Total",
				"bind_time",
				"caozou"
			],
			columnsList: [
				{
					prop: "index",
					label: "用户ID",
					minWidth: "80",
				},
				{
					prop: "DisplayId",
					label: "用户ID",
					minWidth: "80",
				},
				{
					prop: "mobile",
					label: "手机号",
					minWidth: "90"
				},
				{
					prop: "user_name",
					label: "用户昵称",
					minWidth: "90"
				},
				{
					prop: "admin_name",
					label: "员工名",
					minWidth: "80"
				},
				{
					prop: "OnlineTime",
					label: "在线时长(s)",
					minWidth: "100"
				},
				{
					prop: "register_time",
					label: "注册时间",
					minWidth: "120"
				},
				{
					prop: "bind_type",
					label: "绑定方式",
					minWidth: "80"
				},
				{
					prop: "bind_status",
					label: "绑定状态",
					minWidth: "80"
				},
				{
					prop: "refuse_text",
					label: "原因",
					minWidth: "80"
				},
				// {
				// 	prop: "refuse_text",
				// 	label: "绑定说明",
				// 	minWidth: "80"
				// },
				{
					prop: "is_main",
					label: "用户类型",
					minWidth: "80"
				},
				{
					prop: "is_vip",
					label: "优质用户",
					minWidth: "80"
				},
				{
					prop: "RegMachineCode",
					label: "注册设备码",
					minWidth: "120"
				},
				{
					prop: "RegIp",
					label: "注册IP",
					minWidth: "120"
				},
				{
					prop: "CurrMachineCode",
					label: "登录设备码",
					minWidth: "120"
				},
				{
					prop: "CurrIP",
					label: "登录IP",
					minWidth: "120"
				},
				{
					prop: "recharge_total",
					label: "用户充值",
					minWidth: "80"
				},
				{
					prop: "guild_recharge_total",
					label: "公会代充",
					minWidth: "80"
				},
				{
					prop: "Total",
					label: "总充值",
					minWidth: "80"
				},
				{
					prop: "user_pay_total",
					label: "用户流水",
					minWidth: "80"
				},
				{
					prop: "bind_time",
					label: "绑定时间",
					minWidth: "120"
				},
				{
					prop: "created_at",
					label: "创建时间",
					minWidth: "120"
				},
				{
					prop: "app_id",
					label: "APP类型",
					minWidth: "80"
				},
				{
					prop: "caozou",
					label: "操作",
					minWidth: "260"
				},
			]
		};
	},

	computed: {
		columns() {
			let result = this.columnsList.map(item => {
				const index = this.fixed_list.findIndex(itm => {
					return itm == item.prop;
				});
				if (index != -1) {
					// item.fixed = true;
					return item;
				}
			}).filter(ite => typeof ite !== 'undefined');
			return result;
		}
	},
	watch: {
		fixed_list(val) {
			if (val.length > 20) {
				this.fixed_list.shift();
			}
		}
	},


	mounted() {
		this.getInitializeDate();
		this.getList();
		this.getSearchData();

	},

	methods: {
		exportS() {
			this.export_loading = true;
			this.$_invoke("appUser_export3", {
				page: this.page,
				page_size: this.page_size,
				... this.search_data,
			})
				.then((ret) => {
					window.open(ret);
				})
				.finally(() => {
					this.export_loading = false;
				});
		},
		force(id) {
			this.force_id = id;
			this.$nextTick(() => {
				this.force_visible = true;
			});
		},
		// 点击 更改部门
		changes() {
			this.getList();
			this.getSearchData();
		},
		getSearchData() {
			// this.loading = true;
			this.$_invoke("adminUser_getSearchData", {
				corp_id: this.search_data.corp_id,
				depart_id: this.search_data.depart_id,
				group_id: this.search_data.group_id,
			})
				.then((ret) => {
					console.log(ret);
					this.corp_list = ret.corp_list;
					this.depart_list = ret.depart_list;
					this.group_list = ret.group_list;
					this.app_list = ret.app_list;
				})
				.finally(() => {
					// this.loading = false;
				});

		},
		onPick(cant) {
			console.log(this.value2_check)
			if (!this.value2_check) {
				this.value2_check = "";
				this.search_data.start_time = "";
				this.search_data.end_time = "";
			} else {
				this.search_data.start_time = this.value2_check[0];
				this.search_data.end_time = this.value2_check[1];
			}
			if (!cant) {
				this.onSearch();
			}
		},
		getInitializeDate() {
			let date = new Date()
			let year = date.getFullYear().toString()
			//获取当前月份，因为月份是要从0开始，此处要加1，
			let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
			let start = year + '-' + month + '-01 00:00:00'
			let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
			let end = year + '-' + month + '-' + day + ' 23:59:59'
			this.value2_check = [start, end]
		},
		//获取数据
		getList() {
			this.loading = true;
			this.$_invoke("appUser_getList", {
				page: this.page,
				page_size: this.page_size,
				... this.search_data,
			})
				.then((ret) => {
					// this.data = [];
					// console.log(ret.data);
					this.data = ret.data;
					this.count = ret.count;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		//点击搜索按钮
		onSearch() {
			this.page = 1;
			this.rel_search_data = this.search_data;
			this.getList();
		},

		//点击重置搜索框
		clearSearch() {
			this.corp_list = [];
			this.depart_list = [];
			this.group_list = [];
			this.app_list = [];
			this.rel_search_data = {};
			this.search_data.sort = "";
			this.getList();
		},

		//页码改变
		pageChange(page) {
			this.page = page;
			this.getList();
		},

		//每页显示条数改变
		pageSizeChange(page_size) {
			this.page_size = page_size;
			this.getList();
		},


		//添加成功回调
		onAddSucess() {
			this.add_visible = false;
			this.getList();
		},

		//显示修改界面
		showEdit(app_user_id) {
			this.edit_id = app_user_id;
			this.$nextTick(() => {
				this.edit_visible = true;
			});
		},

		//编辑成功回调
		onEditSucess() {
			this.edit_visible = false;
			this.force_visible = false;
			this.getList();
		},

		//显示修改密码界面
		showChangePwd(id) {
			this.change_pwd_id = id;
			this.$nextTick(() => {
				this.show_change_pwd = true;
			});
		},

		//修改密码成功回调
		onChangePwdSuccess() {
			this.show_change_pwd = false;
		},

		beautiful(id) {
			console.log(id);
			this.$confirm("确定更新靓号吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$_invoke(`appUser_beautiful`, { id }).then(() => {
						this.$_msg.success("更新成功");
						this.getList();
					});
				})
				.catch(() => { });
		},
		//删除
		// del(id) {
		// 	this.$confirm("确定删除该条记录吗？", "提示", {
		// 		confirmButtonText: "确定",
		// 		cancelButtonText: "取消",
		// 		type: "warning",
		// 	})
		// 		.then(() => {
		// 			this.$_invoke(`resource_delete`, { id }).then(() => {
		// 				this.$_msg.success("删除成功");
		// 				this.getList();
		// 			});
		// 		})
		// 		.catch(() => { });
		// },
		sortOnlineTime(data) {
			this.search_data.sort = data.order.includes('descending') ? 'desc' : 'asc'
			console.log(this.search_data.sort);
			this.getList();
		},
		//重置固定栏位选择
		resetFixedCheck() {
			this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
		},
	},
};
</script>
